import superagent from 'superagent'
import assert from 'assert'
import { getClientAuthorization } from './getAuthorization'

assert(process.env.EBAY_ACCESS_TOKEN_SERVICE, `Please specify the endpoint for the bay user access token api endpoint (EBAY_ACCESS_TOKEN_SERVICE)

Probably https://api.sandbox.ebay.com/identity/v1/oauth2/token (see https://developer.ebay.com/api-docs)`)
assert(process.env.EBAY_REDIRECT_URI, `Please specify the ebay RuName (redirect uri name) for your application (EBAY_REDIRECT_URI).

This is part of your application settings at https://developer.ebay.com/my/auth`)

/**
 * Exchange the ebay user authorisation code for an user access token set.from ebay required to access the 
 * ebay API
 * 
 * This set represents a short-lived access token (2 hours) and an accompanying refresh token that can be
 * used to request further access tokens
 * 
 * @param {String} decodedAuthCode - Authorisation code from ebay, URL decoded 
 * @throws if the url cannot be resolved or an error is returned by the ebay api. Catch this to avoid your process being exited fatally
 */
const getUserAccessToken = async decodedAuthCode => {

  const res = await superagent.post(`${process.env.EBAY_ACCESS_TOKEN_SERVICE}`)
              .type('form')
              .set('Authorization', getClientAuthorization())
              .send({ "grant_type": 'authorization_code' })
              .send({ "redirect_uri": `${process.env.EBAY_REDIRECT_URI}` })
              .send({ "code": decodedAuthCode })

  return res.body
}

/**
 * Get a new shortlived user access token with an OAuth2 refresh token
 * 
 * @param {String} refreshToken - The ebay supplied OAuth2 refresh token
 * @param {String} scopes - the space delimited list of scopes (https://developer.ebay.com/api-docs/static/oauth-details.html#scopes). Alternatively, supply an array of strings. 
 * @throws if the url cannot be resolved or an error is returned by the ebay api. Catch this to avoid your process being exited fatally
 */
const refreshUserAccessToken = async (refreshToken, scopes) => {
  let encodedScopes = (Array.isArray(scopes) ? scopes.join('%20') : scopes.split(' ').join('%20'))

  const res = await superagent.post(`${process.env.EBAY_ACCESS_TOKEN_SERVICE}`)
              .type('form')
              .set('Authorization', getClientAuthorization())
              .send({ "grant_type": 'refresh_token' })
              .send({ "refresh_token": refreshToken })
              .send({ "scope": encodedScopes })

  return res.body
}

export { 
  getUserAccessToken,
  refreshUserAccessToken
}
